import type {ReactElement} from 'react';
import type {VerticalVideoScrimProps} from './vertical-video-scrim.types';
import styles from './vertical-video-scrim.module.scss';

export function VerticalVideoScrim({className}: VerticalVideoScrimProps): ReactElement {
  return <div className={`${styles.verticalVideoScrim} ${className}`} aria-hidden="true" />;
}
